<style lang="scss">
.workshopCard::-webkit-scrollbar {
  display: none;
}

.gradient-card--condition-met {
  background: linear-gradient(90deg, #ff3a5e 100%, #121212 0%);
  /* 其他卡片样式 */
  /* width: 300px;
     height: 200px;
     border: 1px solid #ccc;
     border-radius: 8px;
     padding: 20px; */
}
</style>

<template>
  <div ref="cardContainer" class="workshopCard" style="overflow: auto;height: 100%;position: relative;">
    <div class="titleBar" style="padding: 20px;display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding-bottom: 10px;">
      <div style="display: flex;margin-left: 0px;align-items: center;">
        <div style="display: flex;align-items: center;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: white;"></div>
          <div style="font-size: 14px;font-weight: bold;color: white;margin-left: 4px;">{{ $t('zongshu') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: white;margin-left: 4px;">{{ equipments.length }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #00A3FF;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #00A3FF;margin-left: 4px;">{{ $t('wukucun') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #00A3FF;margin-left: 4px;">{{ eqStateNum('1') }}</div>
        </div>
        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FFC83A;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ $t('youkucun') }}</div>
          <div style="font-size: 14px;font-weight: bold;;color: #FFC83A;margin-left: 4px;">{{ eqStateNum('2') }}</div>
        </div>
        <!--        <div style="display: flex;align-items: center;margin-left: 24px;">
          <div style="width: 8px;height: 8px;border-radius: 50%;background-color: #FF3A5E;"></div>
          <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{$t('manku')}}
          </div>
          <div style="font-size: 14px;font-weight: bold;;color: #FF3A5E;margin-left: 4px;">{{eqStateNum('3')}}
          </div>
        </div>-->
      </div>
    </div>
    <div class="equipments" :style="{ 'grid-template-columns': 'repeat(auto-fill, ' + monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH + 'px)' }" style=";padding:20px;padding-top: 0;display: grid;grid-template-columns:repeat(auto-fill, 170px);grid-row-gap: 7px;grid-column-gap: 7px;">
      <div :style="{ background: cardBgColor(index) }" @click="showEquipment(equipment)" class="equipment" style="background: #121212;width: 100%;cursor: pointer;border-radius: 4px 4px 4px 4px;" v-for="(equipment, index) in equipments">
        <div :style="{ background: cardBarColor(index) }" style="width: 100%;;height: 8px;border-radius: 4px 4px 0px 0px;"></div>
        <div style="padding: 12px;">
          <div style="display: flex;justify-content: space-between;">
            <p :style="{ color: cardTextColor(index) }" style="font-size: 24px;">{{ equipment.code }}</p>
          </div>
          <p v-show="true" style="line-height:22px;color:#F4F4F4" :style="{ 'font-size': monitorSetting.MONITOR_WORKSHOP_CARD_FONT + 'px' }">
            {{ equipment.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="bottomBar" style="width: 100%;height: 20px;position: sticky;bottom: 0;background: #202027;"></div>
  </div>
</template>
<script type="text/javascript">
const execMathExpress = require('exec-mathexpress');
export default {
  name: 'web_monitor_store_chart_card',
  components: {},
  data() {
    return {
      interval: null,
      isStopListScroll: false,
      timmer: null,
      equipments: [],
      equipmentsPoints: {},
      monitorSetting: null,
      conditions: {
        warehouseLocationCode: '',
        warehouseIds: '',
        status: ''
      }
    };
  },
  // monitorSetting.MONITOR_WORKSHOP_CARD_STYLE
  created() {
    this.setCardSetting();
    this.timmer = setInterval(() => {
      this.listStorageStatus();
    }, 120000);
    this.getMonitorData();
    this.listStorageStatus();

    this.utils.event_hub.$on('STORE_CHART_SEARCH_CONDITIONS', condi => {
      this.conditions = condi;
      this.listStorageStatus();
    });
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('SetCard', () => {
      this.setCardSetting();
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    this.utils.event_hub.$off('SetCard');
    clearInterval(this.timmer);
  },
  watch: {},
  computed: {
    eqStateNum() {
      return state => {
        let num = 0;
        for (var i = 0; i < this.equipments.length; i++) {
          if (state == this.equipments[i].status) {
            num++;
          }
        }
        return num;
      };
    },
    cardBgColor() {
      return index => {
        console.log(this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE);
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          return '#121212';
        } else {
          return {
            // "1": "#00A3FF",
            // "2": "#FFC83A",
            // "3": "#FF3A5E",
            '1': 'linear-gradient(#2697FF, #121212, #121212)',
            '2': 'linear-gradient(#FA9D2D, #121212, #121212)',
            '3': 'linear-gradient(#FF3A5E, #121212, #121212)'
          }[this.equipments[index].status];
        }
      };
    },
    cardBarColor() {
      return index => {
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          return {
            '1': '#00A3FF',
            '2': '#FFC83A',
            '3': '#FF3A5E'
            // "0": "linear-gradient(135deg, #39F16D 0%, #AABF26 100%)",
            // "1": "linear-gradient(135deg, #E49155 0%, #FFD057 100%)",
            // "3": "linear-gradient(135deg, #FF306E 0%, #E47755 100%)",
            // "-1": "linear-gradient(135deg, #858FA3 0%, #6A759A 100%)",
          }[this.equipments[index].status];
        } else {
          return 'none';
        }
      };
    },
    cardTextColor() {
      return index => {
        if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == 'jianyue') {
          return {
            '1': '#00A3FF',
            '2': '#FFC83A',
            '3': '#FF3A5E'
          }[this.equipments[index].status];
        } else {
          return '#f4f4f4';
        }
      };
    }
  },
  methods: {
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }

      const listDiv = this.$refs.cardContainer;

      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    setCardSetting() {
      this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH = 170;
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT = 14;
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE == null) {
        this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE = 'jianyue';
      }
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    },
    showEquipment(equipment) {
      this.utils.event_hub.$emit('SHOW_WORKSHOP_EQUIPMENT', equipment);
    },
    listStorageStatus() {
      // 设置默认的请求参数
      const params = { ...this.conditions };
      this.http
        .get('web/basic/warehouse/listStorageStatus', {
          params: params
        })
        .then(res => {
          this.equipments = res.data;
        });
    },
    getMonitorData() {
      this.http
        .get('web/equipment/getMonitorData', {
          params: {
            orgId: this.$attrs.orgId
          }
        })
        .then(res => {
          this.equipmentsPoints = res.data;
        });
    }
  }
};
</script>
